export default __webpack_public_path__ + "static/media/IMG3122.3ff26f03.jpg";